import { inEnvDev } from '../utils/wz.v2'

export default {
  inEnvDev() {
    return inEnvDev()
  }
}
